import translations from '../../../player/overlay-actions/translations';


export default function getRentStatusConfig({ dgsInfo }) {
  const rentInfo = _.get(dgsInfo, 'rent');

  if (!rentInfo || !rentInfo.expirationTs) {
    return null;
  }

  return {
    translationData: {
      expirationDate: rentInfo.expirationTs * 1000,
      props: translations.rented,
    },
  };
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/new-player/components/selectors/rent-status.js